import { isString } from '@jd/jmtd-tools/es/is';
import download from './download.png';
export var COMMON_LINE_SYMBOL = "path://M3,0.5 C3.69035594,0.5 4.31535594,0.779822031 4.76776695,1.23223305 C5.22017797,1.68464406 5.5,2.30964406 5.5,3 C5.5,3.69035594 5.22017797,4.31535594 4.76776695,4.76776695 C4.31535594,5.22017797\n3.69035594,5.5 3,5.5 C2.30964406,5.5 1.68464406,5.22017797 1.23223305,4.76776695 C0.779822031,4.31535594 0.5,3.69035594 0.5,3 C0.5,2.30964406 0.779822031,1.68464406 1.23223305,1.23223305 C1.68464406,0.779822031 2.30964406,0.5 3,0.5 L3,0.5 Z";
export var COMMON_AXISLABEL_FORMATTER = function COMMON_AXISLABEL_FORMATTER(value) {
  if (isString(value)) {
    return value;
  }

  if (value > 999999999 || value < -999999999) {
    return "".concat((value / 1000000000).toFixed(1), "B");
  }

  if (value > 999999 || value < -999999) {
    return "".concat((value / 1000000).toFixed(1), "M");
  }

  if (value > 999 || value < -999) {
    return "".concat((value / 1000).toFixed(1), "K");
  }

  return value;
};
export var TOOLBOX = {
  toolbox: {
    showTitle: false,
    itemSize: 30,
    feature: {
      saveAsImage: {
        icon: "image://".concat(download)
      }
    },
    tooltip: {
      show: true,
      padding: [6, 12],
      textStyle: {
        fontSize: 12
      },
      formatter: function formatter() {
        return '保存为图片';
      }
    },
    right: 20
  }
};